<template>
  <div class="wrapper wrapper_wide section_content">
    <div class="frame_wide">
      <Greeting v-bind="info"/>
    </div>
    <div class="frame_center">
      <Feature v-bind="home.concept"/>
      <Feature v-bind="home.contact" :imgName="'contact'"/>
      <ReservedBtns />
      <Timetable />
      <AddressMap />
      <Feature v-bind="home.about" :bg="true" :imgName="'about'" :vartical="true" :titlePos="false"/>
      <Facility v-for="(point, idx) in home.points" v-bind="point" :idx="idx"/>
      <Feature v-bind="home.gallary" :bg="true" :imgName="'gallary'" />
      <Fusion />
      <Consultation />
    </div>
  </div>
</template>

<script>
// molcules
import ReservedBtns from '../molcules/reserved_btns.vue'

// organisms
import AddressMap from '../organisms/addressMap.vue'
import Facility from '../organisms/facility.vue'
import Feature from '../organisms/feature.vue'
import Fusion from '../organisms/fusion.vue'
import Greeting from '../organisms/greeting.vue'
import Timetable from '../organisms/timetable.vue'
import Consultation from '../organisms/consultation.vue'

import { mapState } from 'vuex'

export default {
  name: 'HomeContents',
  components: {
    ReservedBtns,
    AddressMap,
    Facility,
    Feature,
    Fusion,
    Greeting,
    Timetable,
    Consultation
  },
  props: {
    msg: String
  },
  data () {
    return {
      home: siteData.home,
      info: siteData.info,
      detail: siteData.detail
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
